
	export default {
		data() {
			return {
				isDark: false,
			}
		},
		computed: {
			theme() {
				return this.$store.state.theme.name;
			},
		},
		mounted() {
			this.isDark = this.$store.state.theme.name === "dark";
		},
		methods: {
			changeTheme() {
				this.$store.commit("theme/toggle", this.isDark ? "dark" : "light");
			},
		}
	}
